import React, { useRef } from "react";
import "./fileuploader.css";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import DeleteIcon from '@material-ui/icons/Delete';


function FileUploader({handleCoverImageUpload,image,removeHeadImage, editImage,allowTypes}) {
    const fileUpload = useRef(null);
    const imageUpload = (e) => {
        fileUpload.current.click();
    };
    const getFile = (e) => {
        e.preventDefault();
        handleCoverImageUpload(e)
        
    };
    const getFileThroughDrag = (e) => {
        e.preventDefault();
    }
    return (
        <React.Fragment>
            <input type="file" accept={allowTypes} hidden ref={fileUpload}  onChange={(e) => getFile(e)}/>
            {image ? (
                <div className="imageWrapper h-100 w-full cursor-pointer relative shadow" onDragOver={(e) => { e.preventDefault(); e.stopPropagation() }}
                    onDrop={(e) => getFileThroughDrag(e)}>
                    <div className="imageUploadOverlay" onClick={(e) => imageUpload(e)}></div>
                    <img
                        src={image}
                        alt="img"
                        className="coverImage h-100 w-full object-cover"
                        onClick={(e) => imageUpload(e)}
                    />
                    <DeleteIcon className="removeImage cursor-pointer" onClick={() => removeHeadImage()} />
                </div>
            ) : (
                <div
                    className="imagePinArea h-100 w-full rounded-md relative cursor-pointer dropZone"
                    onClick={(e) => imageUpload(e)}
                    onDragOver={(e) => { e.preventDefault(); e.stopPropagation() }}
                    onDrop={(e) => getFileThroughDrag(e)}
                >
                    <div className="uploadIcons perfectCenter">
                        <AddPhotoAlternateIcon className="addPhotosize" />
                        {/* or
                        <p>Drag the Image</p> */}
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

export default FileUploader;
